// Iter 298 — 📡 Admin consultable HORS LIGNE (lecture seule).
// Les GET /api/admin réussis sont mémorisés localement et resservis
// automatiquement quand le réseau coupe. Les écritures restent bloquées
// (sauf pointage/encaissement Jour J qui ont leur propre file).
import axios from 'axios';

const PREFIX = 'raavcache:';
const IDX_KEY = 'raavcache-index';
const MAX_ENTRIES = 40;
const MAX_ENTRY_SIZE = 350000;

const lireIndex = () => { try { return JSON.parse(localStorage.getItem(IDX_KEY)) || {}; } catch { return {}; } };
const ecrireIndex = (idx) => { try { localStorage.setItem(IDX_KEY, JSON.stringify(idx)); } catch { /* plein */ } };
const cleDe = (cfg) => `${cfg.url}|${JSON.stringify(cfg.params || {})}`;

const evincer = (idx, n) => {
  Object.keys(idx).sort((a, b) => idx[a] - idx[b]).slice(0, n).forEach(k => {
    delete idx[k];
    try { localStorage.removeItem(PREFIX + k); } catch { /* déjà parti */ }
  });
};

const sauver = (k, data) => {
  const s = JSON.stringify({ t: Date.now(), d: data });
  if (s.length > MAX_ENTRY_SIZE) return;
  const idx = lireIndex();
  const keys = Object.keys(idx);
  if (keys.length >= MAX_ENTRIES && !idx[k]) evincer(idx, keys.length - MAX_ENTRIES + 1);
  try {
    localStorage.setItem(PREFIX + k, s);
  } catch {
    evincer(idx, Math.ceil(Object.keys(idx).length / 2));
    try { localStorage.setItem(PREFIX + k, s); } catch { ecrireIndex(idx); return; }
  }
  idx[k] = Date.now();
  ecrireIndex(idx);
};

const relire = (k) => { try { return JSON.parse(localStorage.getItem(PREFIX + k)); } catch { return null; } };

let installe = false;
export const installerCacheHorsLigne = () => {
  if (installe) return;
  installe = true;
  axios.interceptors.response.use(
    (res) => {
      const cfg = res.config || {};
      if ((cfg.method || 'get').toLowerCase() === 'get' && (cfg.url || '').includes('/api/admin/')) {
        try { sauver(cleDe(cfg), res.data); } catch { /* jamais bloquant */ }
      }
      return res;
    },
    (err) => {
      const cfg = err.config || {};
      if (!err.response && (cfg.method || 'get').toLowerCase() === 'get' && (cfg.url || '').includes('/api/admin/')) {
        const hit = relire(cleDe(cfg));
        if (hit) {
          window.dispatchEvent(new CustomEvent('raav-offline-lecture', { detail: { t: hit.t } }));
          return Promise.resolve({
            data: hit.d, status: 200, statusText: 'OK (cache hors ligne)',
            headers: {}, config: cfg, offline: true, offlineAt: hit.t,
          });
        }
        window.dispatchEvent(new CustomEvent('raav-offline-lecture', { detail: { t: null } }));
      }
      return Promise.reject(err);
    }
  );
};
